import React, { useRef, useState, useCallback } from "react";
import { MoveHorizontal } from "lucide-react";

// Comparateur avant/après avec poignée déplaçable.
export default function BeforeAfter({ before, after, label, testid }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const update = useCallback((clientX) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, pct)));
  }, []);

  const onDown = () => { dragging.current = true; };
  const onUp = () => { dragging.current = false; };
  const onMove = (e) => {
    if (!dragging.current) return;
    update(e.clientX);
  };
  const onTouch = (e) => update(e.touches[0].clientX);

  return (
    <div
      ref={ref}
      data-testid={testid}
      className="relative aspect-[4/3] w-full overflow-hidden rounded-3xl border border-ink/10 select-none cursor-ew-resize bg-ink"
      onMouseMove={onMove}
      onMouseUp={onUp}
      onMouseLeave={onUp}
      onMouseDown={(e) => { onDown(); update(e.clientX); }}
      onTouchStart={onDown}
      onTouchMove={onTouch}
      onTouchEnd={onUp}
    >
      {/* Après (fond) */}
      <img src={after} alt={`${label} — après`} className="absolute inset-0 h-full w-full object-cover pointer-events-none" />
      <span className="absolute right-4 top-4 rounded-full bg-aqua px-3 py-1 text-xs font-bold text-white z-10">APRÈS</span>

      {/* Avant (recadré par clip) */}
      <div className="absolute inset-0 pointer-events-none" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before} alt={`${label} — avant`} className="absolute inset-0 h-full w-full object-cover" />
        <span className="absolute left-4 top-4 rounded-full bg-ink px-3 py-1 text-xs font-bold text-white">AVANT</span>
      </div>

      {/* Poignée */}
      <div className="absolute top-0 bottom-0 z-10 w-0.5 bg-white pointer-events-none" style={{ left: `${pos}%` }}>
        <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex h-11 w-11 items-center justify-center rounded-full bg-white text-ink shadow-lg">
          <MoveHorizontal size={20} />
        </span>
      </div>

      {label && (
        <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-ink/90 to-transparent p-5 pointer-events-none">
          <p className="text-sm font-bold text-white">{label}</p>
        </div>
      )}
    </div>
  );
}
